import { DISTRIBUTION_URL, JSONAPI_URL } from "../../../services/common-urls";
import { JSON_STRING, MHTTPCL, createHttpGetOptions } from "../../../services/http/http-client";

export const DistributionImportsService = {
  findImportsList: () => MHTTPCL.post(DISTRIBUTION_URL, {
    section: 'statementsin',
    action: 'statement_overview',
  }),
  getSalesMatrixData: (start_date, end_date, searchString, channel,offset,row_count) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: 'statementsin',
    action: 'sales_matrix_data',
    row_count: row_count,
    offset: offset,
    start_date: start_date,
    end_date: end_date,
    str: searchString,
    channel: channel
  }),


  uploadFile: (formData, postOptions) => {
    return MHTTPCL.postFormData(DISTRIBUTION_URL, formData, postOptions);
  },
  createStatement: ({
    statement_setting_id,
    sender,
    royalty_period_id,
    year,
    period,
  }) => {
    return MHTTPCL.post(DISTRIBUTION_URL, {
      section: 'statementsin',
      action: 'create_rp_statement',

      statement_setting_id,
      sender,
      royalty_period_id,
      year,
      period,
    })
  },
  fetchAddImportData: () => MHTTPCL.post(DISTRIBUTION_URL, {
    section: 'accounts',
    action: 'account_statememnt_setup_form1',
  }),

  processStatement: (statement_id, file_type, write_time) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "statementsin",
    action: "process_statement",
    statement_id: statement_id,
    file_type: file_type,
    write_time: write_time,
    output: JSON_STRING
  }),



  stmtInvoiceContactList: () => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "stmt_invoice_contact_list"
  }),

  searchStmtInvoiceContactList: (searchString) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "search_stmt_invoice_contact_list",
    search: searchString
  }),

  getContact: (contact_id) => MHTTPCL.post(JSONAPI_URL, {
    action: "get_contact",
    contact_id: contact_id
  }),

  newEditStmtSettings: ({ account_id, description, invoice_project_id, digital_physical, statement_period, fix_country = "", start_date = "", end_date = "", dss_id = "", sender = "", shared_key = "", statement_preset_id = "", currency_id, fix_shop, fix_digital_type = "", distribution_fee_sales = "", distribution_fee_returns = "", contact_id_invoice }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "accounts",
    action: "new_edit_stmt_settings",
    account_id: account_id,
    description: description,
    invoice_project_id: invoice_project_id,
    digital_physical: digital_physical,
    statement_period: statement_period,
    fix_country: fix_country,
    start_date: start_date,
    end_date: end_date,
    dss_id: dss_id,
    sender: sender,
    shared_key: shared_key,
    statement_preset_id: statement_preset_id,
    currency_id: currency_id,
    fix_shop: fix_shop,
    fix_digital_type: fix_digital_type,
    distribution_fee_sales: distribution_fee_sales,
    distribution_fee_returns: distribution_fee_returns,
    contact_id_invoice: contact_id_invoice
  })






}